<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center" class="mt-4 ml-4">
        <v-col>
          <span class="text-h5 font-weight-bold" v-text="'Shift Management'"></span>
          <v-btn class="mx-2 mb-2" fab x-small color="primary" to="/shift-managements/create">
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-text>
              <v-row align="center">
                <v-col md="4">
                  <v-text-field v-model="search_keyword" label="Search ... " prepend-inner-icon="mdi-magnify"
                    outlined dense hide-details clearable @keydown.enter="getData" @change="page = 1"></v-text-field>
                </v-col>
                <v-col md="3" v-if="allCompanies.length > 0">
                  <v-autocomplete v-model="filter_company_id" :items="allCompanies" label="Company"
                    prepend-inner-icon="mdi-domain" outlined dense hide-details clearable @input="getData"></v-autocomplete>
                </v-col>
                <v-spacer></v-spacer>
                <v-col md="3">
                  <v-pagination v-model="page" :length="paginationLength"></v-pagination>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-progress-linear v-if="isLoading" indeterminate color="primary"></v-progress-linear>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Shift Name</th>
                    <th class="text-left">Start Time</th>
                    <th class="text-left">End Time</th>
                    <th class="text-left">Late Mark</th>
                    <th class="text-left">Half Day Before Time</th>
                    <th class="text-left" v-if="allCompanies.length > 0">Company</th>
                    <th class="text-left">Status</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody v-if="shifts.length != 0">
                  <tr v-for="(shift, i) in shifts" :key="`shift${i}`">
                    <td>
                      <v-tooltip bottom v-if="shift.is_active == 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" small dark color="green">
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>Shift is Active</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="shift.is_active == 0">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" small dark color="red">
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>Shift is InActive</span>
                      </v-tooltip>
                      &nbsp;
                      {{ i + 1 }}
                    </td>
                    <td>{{ shift.shift_name }}</td>
                    <td>{{ shift.start_time }}</td>
                    <td>{{ shift.end_time }}</td>
                    <td>{{ shift.late_mark }}</td>
                    <td>{{ shift.half_day_before_time }}</td>
                    <td v-if="allCompanies.length > 0">
                      <v-chip small color="blue-grey lighten-4" text-color="blue-grey darken-3" v-if="shift.company">
                        {{ shift.company.name }}
                      </v-chip>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <v-chip small :color="shift.is_active ? 'green' : 'red'" dark>
                        {{ shift.is_active ? 'Active' : 'Inactive' }}
                      </v-chip>
                    </td>
                    <td class="text-right">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" icon :to="`/shift-managements/${shift.id}`">
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Edit</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" icon @click="deleteShift(shift.id)">
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Delete</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td :colspan="allCompanies.length > 0 ? 9 : 8" class="text-center">No shifts found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      search_keyword: "",
      page: 1,
      paginationLength: 1,
      shifts: [],
      isLoading: true,
      filter_company_id: "",
      allCompanies: [],
    };
  },
  mounted() {
    this.getMasters();
    this.getData();
  },
  watch: {
    page() {
      this.getData();
    },
  },
  methods: {
    async getMasters() {
      try {
        const response = await axios.get("/shift_managements/masters");
        if (response.data.companies && response.data.companies.length > 0) {
          this.allCompanies = [{ text: "All Companies", value: "all" }];
          response.data.companies.forEach((c) => {
            this.allCompanies.push({ text: c.name, value: c.id });
          });
        }
      } catch (e) {
        console.error("Error fetching masters:", e);
      }
    },
    async getData() {
      this.isLoading = true;
      try {
        const response = await axios.get("/shift_managements", {
          params: {
            page: this.page,
            rowsPerPage: this.rowsPerPage,
            search_keyword: this.search_keyword,
            filter_company_id: this.filter_company_id || "",
          },
        });
        this.shifts = response.data.data;
        this.paginationLength = Math.ceil(response.data.count / this.rowsPerPage);
      } catch (error) {
        console.error("Error fetching shifts:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async deleteShift(id) {
      if (confirm("Are you sure you want to delete this shift?")) {
        try {
          await axios.delete(`/shift_managements/${id}`);
          this.$toast.success("Shift deleted successfully");
          this.getData();
        } catch (error) {
          console.error("Error deleting shift:", error);
        }
      }
    },
  },
};
</script>